import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./i18n/i18n";
import "./styles/global.css";
import "./styles/dataTable.css";
import { installAxeDevTools } from "./a11y/axeDevTools";
import { App } from "./App";
import { initialiseInstallSupport } from "./pwa/installPrompt";

installAxeDevTools();
initialiseInstallSupport();

const container = document.getElementById("root");
if (container === null) {
  throw new Error("The #root element is missing from index.html.");
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
